import React from 'react';
import { useAppSelector } from '../../../data/store';
import Step1CartItemMobile from '../cart-item/step-1-cart-item-mobile';
import UndoCartItems from '../undo-cart-items/undo-cart-items';
import GroupRadio from '../cart-item/group-radio';
import { splitCartDataItemPerGroups } from '../../../data/data-provider';
import FreeWithYourPurchase from '../../free-with-your-purchase/free-with-your-purchase';

const Step1ProductsListMobile = () => {

    const cartData = useAppSelector(store => store.root.cartData);
    const groups = splitCartDataItemPerGroups(cartData);

    return (
        <>
            <div className="w-full md:hidden">
                <UndoCartItems />
            </div>

            <div className="w-full md:w-auto">
                {
                    groups.map((group, i) => {

                        const isGroupSelected = group.cartGroupID === cartData.cartGroupID;

                        return (
                            <div
                                className={`border rounded flex flex-col md:hidden w-full mb-6 ${ isGroupSelected ? 'bg-white' : 'bg-gray-150' }`}
                                key={ group.cartGroupID }>
                                <div className="px-4 py-2 border-b">
                                    <GroupRadio group={ group }  name="cart-group-mobile" />
                                </div>
                                {
                                    group.cartItems && group.cartItems.map((cartItem, i) => {

                                        const isLastItem = group.cartItems && (i === group.cartItems.length - 1);

                                        return (
                                            <Step1CartItemMobile
                                                key={ cartItem.cartItemGUID }
                                                cartItem={ cartItem }
                                                isLastItem={ !!isLastItem }
                                            />
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }
            </div>

            <div className="w-full md:hidden">
                <FreeWithYourPurchase />
            </div>
        </>
    )
};

export default Step1ProductsListMobile;